import React from "react";
import { View, ScrollView, StyleSheet, Platform, Text } from "react-native";
import appStyles from "../../../../appStyles";
import Header from "../../../common/header/index";
import appPages from "../../../../../appPages";
import Channel from "./Channel";

export default function AccountEdit({
  account,
  goBack = () => {},
  saveIntegrations = () => {},
  disconnectAccount = () => {},
}) {
  const channels = account.channels || [];

  const updateChannelSettings = (c, isSelected) => {
    c.isSelected = isSelected;
    saveIntegrations({
      id: account.id,
      streamId: c.id,
      streamEnabled: isSelected,
    });
  };

  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title={account.name}
        subTitle="Choose which channels to connect to Mana"
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <ScrollView
        contentContainerStyle={appStyles.scrollViewContent}
        style={appStyles.scrollView}
      >
        {channels.map((cal, index) => (
          <Channel item={cal} key={index} onToggle={updateChannelSettings} />
        ))}

        <Text style={styles.linkText} onPress={disconnectAccount}>
          Disconnect this account
        </Text>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  linkText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#DD5F43",
    width: "100%",
    textAlign: "center",
    marginTop: 32,
  },
  button: {
    width: 183,
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
